import Trash from 'components/icons/trash';
import Pencil from 'components/icons/pencil2';
import ButtonIcon from 'components/ButtonIcon';
import { Topic } from 'data/firestore/agent/topic/types';
import { EntityGet } from 'data/firestore/types';
import useManageTopics from 'data/hooks/useManageTopics';
import { ADD_EDIT_TOPIC_DRAWER } from '../../../constants';
import { ActionsColumnContainer } from '../styled';

interface ActionsColumnProps {
    agentId: string;
    row?: EntityGet<Topic>;
}

const ActionsColumn = ({
    agentId,
    row,
}: ActionsColumnProps) => {
    const { edit: editTopic, remove: removeTopic } = useManageTopics({
        agentId,
        modalId: ADD_EDIT_TOPIC_DRAWER,
    });

    return (
        <ActionsColumnContainer>
            <ButtonIcon
                borderRadius="semi-rounded"
                icon={<Pencil />}
                tooltip="Edit tag description"
                disabled={!row?.removable}
                onClick={() => editTopic(row as Topic)}
            />
            <ButtonIcon
                borderRadius="semi-rounded"
                icon={<Trash />}
                tooltip="Remove tag"
                disabled={!row?.removable}
                onClick={() => removeTopic(row?.id as string)}
            />
        </ActionsColumnContainer>
    );
};

export default ActionsColumn;
